import { Fragment, useMemo } from 'react'

import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'
import { useMileageClerkNavigation } from './hooks/useMileageClerkNavigation'
import { useControllerNavigation } from './hooks/useControllerNavigation'
import { usePMNavigation } from './hooks/usePMNavigation'
import { useReaderNavigation } from './hooks/useReaderNavigation'

import styles from './NavigationBar.module.scss'

import ChevronLeftIcon from './assets/chevron-left.svg'
import DividerIcon from './assets/divider.svg'

export const NavigationBar = () => {
    const { role } = useAuthStore()

    const mileageClerkConfig = useMileageClerkNavigation()
    const controllerConfig = useControllerNavigation()
    const performanceManagerConfig = usePMNavigation()
    const readerConfig = useReaderNavigation()

    const config = useMemo(() => {
        switch (role) {
            case Role.MileageClerk: {
                return mileageClerkConfig
            }
            case Role.Controller: {
                return controllerConfig
            }
            case Role.PerformanceManager: {
                return performanceManagerConfig
            }
            case Role.Reader: {
                return readerConfig
            }
            default: {
                return null
            }
        }
    }, [role, mileageClerkConfig, controllerConfig, performanceManagerConfig, readerConfig])

    if (!config || !config.backCallback) {
        return <div className={styles.placeholder} />
    }

    return (
        <nav className={styles.root}>
            <a className={styles.backLink} onClick={config.backCallback}>
                <ChevronLeftIcon />
            </a>
            {config.paths.map((path, index, array) => (
                <Fragment key={index}>
                    {array.length - 1 === index ? (
                        <p className={styles.hint}>{path}</p>
                    ) : (
                        <>
                            <p className={styles.text}>{path}</p>
                            <p className={styles.divider}>
                                <DividerIcon />
                            </p>
                        </>
                    )}
                </Fragment>
            ))}
        </nav>
    )
}
